import styled from "styled-components";
import animate from "../../../utils/animations";

export const Wrapper = styled.div`
  position: absolute;
  height: 100%;
  background: #fff;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 1;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 95px;
`;

export const Text = styled.div`
  display: flex;
  font-size: ${(props) => props.fontSize === "large" && "1.7em"};
  font-size: ${(props) => props.fontSize === "medium" && "1.35em"};
  font-size: ${(props) => props.fontSize === "small" && "1em"};
  ${animate("fadeInUp", 0.3, 0.2)};
`;

export const Spinner = styled.img`
  width: 40px;
  height: 40px;
  align-self: center;
  ${animate("fadeInUp", 0.3, 0.1)};
`;
